/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "AD job deleted successfully." |
*
* @param {Ad_Job_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_deleted_success = /** @type {((inputs?: Ad_Job_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tâche AD supprimée avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Auftrag erfolgreich gelöscht.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Processo AD eliminato correttamente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Задание Active Directory успешно удалено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tarea de AD eliminada correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AD作业已成功删除。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADジョブは正常に削除されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD जॉब सफलतापूर्वक डिलीट हो गया।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tarefa do AD excluída com sucesso.")
	return /** @type {LocalizedString} */ ("AD job deleted successfully.")
});